import axios from 'axios'
import { useCallback } from 'react'
import { useAuthCallPromise } from 'use-eazy-auth'

export function useChangePassword() {
  const changePassword = useAuthCallPromise(
    useCallback(
      (token: string) => (data: { password: string }) =>
        axios
          .put('/api/admin/change-password/', data, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((r) => r.data as void),
      []
    )
  )
  return changePassword
}
